

<script>
const nickname = '';
const headimgurl = '';
export default {
  nickname,
  headimgurl,
}
</script>





// WEBPACK FOOTER //
// src/components/utils/Common.vue